import { ITotalLandDamage } from '../../interfaces/itotal-land-damage';
import { LandArea } from '../land-area';
import { UnitOfMeasure } from '../unit-of-measure';

export class TotalLandDamageBase {
  TotalLandDamageId: number;
  LandAreaId: number;
  PadSize: number;
  UnitCost: number;
  UnitOfMeasureId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  LandArea?: LandArea;
  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: ITotalLandDamage) {
    if (item) {

      this.TotalLandDamageId = item.TotalLandDamageId;
      this.LandAreaId = item.LandAreaId;
      this.PadSize = item.PadSize;
      this.UnitCost = item.UnitCost;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.LandArea = new LandArea(item.LandArea);
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}